import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { Menu } from "lucide-react";

const Header = () => {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-card/95 backdrop-blur-md border-b border-border shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex items-center">
            <h1 className="text-2xl font-bold">
              <span className="text-foreground">Karpa</span>
              <span className="bg-gradient-primary bg-clip-text text-transparent ml-1">Investimentos</span>
            </h1>
          </div>

          {/* Navigation Links */}
          <nav className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('how-it-works')}
              className="text-muted-foreground hover:text-foreground transition-colors font-semibold"
            >
              Como Funciona
            </button>
            <button 
              onClick={() => scrollToSection('differentials')}
              className="text-muted-foreground hover:text-foreground transition-colors font-semibold"
            >
              Por que escolher
            </button>
            <button 
              onClick={() => scrollToSection('testimonials')}
              className="text-muted-foreground hover:text-foreground transition-colors font-semibold"
            >
              Depoimentos
            </button>
            <button 
              onClick={() => scrollToSection('faq')}
              className="text-muted-foreground hover:text-foreground transition-colors font-semibold"
            >
              FAQ
            </button>
          </nav>

          {/* Desktop CTA Button */}
          <Button 
            variant="hero" 
            size="lg" 
            className="hidden sm:flex"
            onClick={() => scrollToSection('contato')}
          >
            Entre em Contato
          </Button>

          {/* Mobile Menu */}
          <Sheet>
            <SheetTrigger asChild>
              <Button variant="ghost" size="icon" className="md:hidden">
                <Menu className="h-6 w-6" />
              </Button>
            </SheetTrigger>
            <SheetContent side="right" className="w-64">
              <nav className="flex flex-col space-y-6 mt-8">
                <button 
                  onClick={() => scrollToSection('how-it-works')}
                  className="text-left text-muted-foreground hover:text-foreground transition-colors font-semibold text-lg"
                >
                  Como Funciona
                </button>
                <button 
                  onClick={() => scrollToSection('differentials')}
                  className="text-left text-muted-foreground hover:text-foreground transition-colors font-semibold text-lg"
                >
                  Por que escolher
                </button>
                <button 
                  onClick={() => scrollToSection('testimonials')}
                  className="text-left text-muted-foreground hover:text-foreground transition-colors font-semibold text-lg"
                >
                  Depoimentos
                </button>
                <button 
                  onClick={() => scrollToSection('faq')}
                  className="text-left text-muted-foreground hover:text-foreground transition-colors font-semibold text-lg"
                >
                  FAQ
                </button>
                <Button 
                  variant="hero" 
                  size="lg" 
                  className="mt-6"
                  onClick={() => scrollToSection('contato')}
                >
                  Entre em Contato
                </Button>
              </nav>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
};

export default Header;